

































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import IQuestion from '@/models/IQuestion';
import IComment from '@/components/icons/IComment.vue';

@Component({
  name: "Comment",
  components: {IComment}
})
export default class Comment extends Vue {
  @Prop({type: Array, default: () => []}) item!: IQuestion[]
  post = 0

  @Watch('item')
  getPostSignature(val: any) {
    this.post = val.filter((ele: any) => {
      return ele.type === 'text'
    }).length
  }
  mounted(){
    this.post = this.item.filter((ele: any) => {
      return ele.type === 'text'
    }).length
  }
}
